import { Row, RowSpan } from 'components/checkout/caap/Layout';
import css from 'styles/components/checkout/caap/payment/paymentlist/paymentlistitemheaderdesktop.scss';

const PaymentListItemHeaderDesktop = () => (
  <Row desktopOnly={true}>
    <Row extraClass={css.paymentListHeader}>
      <RowSpan span="6">Your credit and debit cards</RowSpan>
      <RowSpan span="3"><span className={css.secondaryTitle}>Name on card</span></RowSpan>
      <RowSpan span="3" isLast={true}><span className={css.secondaryTitle}>Expires on</span></RowSpan>
    </Row>
  </Row>
);

export default PaymentListItemHeaderDesktop;
